import React from 'react';
import { Grid } from '@material-ui/core';
import Link from 'gatsby-plugin-transition-link/AniLink';
import { string, shape, bool } from 'prop-types';
import styles from './style.module.scss';
import HeadlineSmall from '../../components/HeadlineSmall';
import Image from '../../components/Image';
import variables from '../../styles/variables.module.scss';

const CaseCard = ({
  color,
  caseImg,
  caseBg,
  caseImgLeftAlign,
  caseImgRightAlign,
  titleSmall,
  title,
  description,
  path,
  isWeb,
  isAndroid,
  textColor,
}) => {
  const renderImage = () => {
    if (caseImgLeftAlign) {
      return (
        <Image
          className={styles.imageLeft}
          source={caseImgLeftAlign}
          alt="iphone"
        />
      );
    }
    if (caseImgRightAlign) {
      return (
        <Image
          className={styles.imageRight}
          source={caseImgRightAlign}
          alt="iphone"
        />
      );
    }
    if (caseImg) {
      return (
        <Image
          className={[
            styles.image,
            isWeb && styles.imageWeb,
            isAndroid && styles.imageAndroid,
          ].join(' ')}
          source={caseImg}
          alt="drumster iphone"
        />
      );
    }
  };

  return (
    <Link fade to={path} style={{ textDecoration: 'none' }}>
      <div
        className={[
          styles.containerMain,
          caseBg && styles.containerMainBg,
        ].join(' ')}
        style={{
          backgroundColor: color,
          backgroundImage: `url(${caseBg})`,
        }}
      >
        <Grid
          container
          className={styles.container}
          justify="flex-end"
          direction="column"
        >
          {!caseBg && renderImage()}
          <Grid item className={styles.headLine}>
            <HeadlineSmall color={textColor}>
              {titleSmall}
            </HeadlineSmall>
            <h4 style={textColor && { color: textColor }}>{title}</h4>
            <p style={textColor && { color: textColor }}>{description}</p>
          </Grid>
        </Grid>
      </div>
    </Link>
  );
};

CaseCard.propTypes = {
  color: string,
  caseImg: shape({
    main: string,
    fall: string,
  }),
  caseImgLeftAlign: shape({
    main: string,
    fall: string,
  }),
  caseImgRightAlign: shape({
    main: string,
    fall: string,
  }),
  titleSmall: string,
  title: string,
  description: string,
  path: string,
  isWeb: bool,
  isAndroid: bool,
  caseBg: string,
  textColor: string,
};

CaseCard.defaultProps = {
  color: variables.springGreen,
  caseImg: null,
  caseImgLeftAlign: null,
  caseImgRightAlign: null,
  titleSmall: null,
  title: null,
  description: null,
  path: '/cases',
  isWeb: false,
  isAndroid: false,
  caseBg: null,
  textColor: variables.cleanWhite,
};

export default CaseCard;
